import { HttpHeaders } from '@angular/common/http';
import {
  ConsultationFormAssignmentResponse,
  ConsultationFormResponse,
  IntakeFormApi,
  IntakeFormRequest,
  Page,
  SaveIntakeFormProgressRequest,
  SignIntakeFormRequest,
} from '@models';
import { Observable } from 'rxjs';

export abstract class IntakeFormsService {
  abstract getIntakeForms(
    params: IntakeFormRequest
  ): Observable<Page<IntakeFormApi>>;

  abstract getIntakeForm(
    id: string,
    options?: { headers: HttpHeaders }
  ): Observable<ConsultationFormResponse>;

  abstract assignToPatient(
    patientId: string
  ): Observable<ConsultationFormAssignmentResponse>;

  abstract sign(
    submissionId: string,
    body: SignIntakeFormRequest,
    options?: { headers: HttpHeaders }
  ): Observable<string>;

  abstract deleteSubmission(submissionId: string): Observable<unknown>;

  abstract getPdf(
    submissionId: string,
    action?: 'Download' | 'View'
  ): Observable<Blob>;

  abstract markAsOpened(
    submissionId: string,
    headers?: HttpHeaders
  ): Observable<void>;

  abstract saveProgress(
    submissionId: string,
    body: SaveIntakeFormProgressRequest
  ): Observable<unknown>;

  abstract complete(
    submissionId: string,
    body: SignIntakeFormRequest
  ): Observable<unknown>;
}
